import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {CommentCreate} from '../../shared/models/comment.model';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-form-edit-user-comment',
    templateUrl: './form-edit-user-comment.component.html',
    styleUrls: ['./form-edit-user-comment.component.css']
})
export class FormEditUserCommentComponent implements OnInit, OnDestroy {

    @Input() edit_user_id: number;
    @Input() user_id: number;
    commentForm: FormGroup;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService) {
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.commentForm = new FormGroup({
            'comment': new FormControl()
        });
    }

    onSubmit() {
        const commentCreate = new CommentCreate(this.commentForm.get('comment').value, this.user_id);
        commentCreate.edit_user_id = this.edit_user_id;
        this.dataStorageService.createCommentEditUser(commentCreate)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    alert('saving comment error');
                } else {
                    alert('comment added. ');
                    location.reload();
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
